var React = require('react');

function IconLockCloseSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M753.8 384.6v-80.3c0-132.7-107.9-241.1-241-241.1-132.8 0-241 107.9-241 241.1v80.3h-60.3c-11 0-20 9-20 20v533.9c0 11 9 20 20 20h602.6c11 0 20-9 20-20V404.6c0-11-9-20-20-20h-60.3zM513 791.6c-66.6 0-120.5-54-120.5-120.5s54-120.5 120.5-120.5 120.5 54 120.5 120.5c.1 66.5-53.9 120.5-120.5 120.5zm160.6-407H352.2v-76.2c0-89.2 71.3-161.5 160.7-161.5 88.8 0 160.7 72.1 160.7 161.5v76.2z"}));
}

IconLockCloseSolid.displayName = "IconLockCloseSolid";

IconLockCloseSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconLockCloseSolid;

IconLockCloseSolid.default = IconLockCloseSolid;
